import axios from 'axios';

// Uncomment the value here before building
// The value set here will be used on the bundle once deployed
export const fetcher = async (method, path, data?) => {
  const rootURL = 'https://wcra-platform-api-prod.herokuapp.com';
  // const rootURL = 'https://wcra-platform-api-prod-mirror.herokuapp.com';
  // const rootURL = 'https://wcra-platform-api-staging.herokuapp.com';
  // const rootURL = 'https://wcra-platform-api-dev.herokuapp.com';
  // const rootURL = 'http://localhost:5000';

  const axiosConfig = {
    method,
    url: rootURL+path,
    data
  };
  
  return await axios(axiosConfig);
};
